import React from 'react';
import { Line } from 'react-chartjs-2';
import { tinycolor } from '@ctrl/tinycolor';
import _ from 'lodash';

class PerDayChart extends React.Component {
    render() {
        var colours = {};

        const all_product_references = _.map(this.props.data.data, (x, i) => i);

        for (var i = 0; i < all_product_references.length; i++) {
            colours[all_product_references[i]] = {
                h: ((360.0 / all_product_references.length) * i), //random hue
                s: 0.9,
                l: 0.5,
                a: 1
            };
        }

        return (
            <Line
                data={{
                    labels: this.props.data.labels,
                    datasets: _.map(
                        this.props.data.data,
                        (x, i) => ({
                            label: i,
                            data: x,
                            fill: false,
                            borderColor: tinycolor(colours[i]).toRgbString(),
                            backgroundColor: tinycolor({ ...colours[i], a: 0.4 }).toRgbString(),
                            pointBorderColor: tinycolor(colours[i]).toRgbString(),
                            pointBackgroundColor: '#fff',
                            pointBorderWidth: 1,
                            pointHoverRadius: 5,
                            pointHoverBackgroundColor: tinycolor(colours[i]).toRgbString(),
                            pointHoverBorderColor: 'rgba(220,220,220,1)',
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 10,
                        })
                    )
                }}
            />
        );
    }
}


export default PerDayChart;
